(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collage-slider"] && !Shopify.designMode) return;
  try {
    
  class CollageSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.collage-slider__track');
      this.slides = this.querySelectorAll('.collage-slider__slide');
      this.prevBtn = this.querySelector('.collage-slider__btn--prev');
      this.nextBtn = this.querySelector('.collage-slider__btn--next');

      const sectionId = this.dataset.section;
      this.dotsContainer = document.querySelector('.collage-slider__dots[data-slider="' + sectionId + '"]');
      this.dots = this.dotsContainer ? this.dotsContainer.querySelectorAll('.collage-slider__dot') : null;

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.navigate(-1));
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.navigate(1));

      if (this.dots) {
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => this.goTo(i)));
      }

      if (this.track) {
        this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });
      }

      this.updateButtons();
    }

    getSlideWidth() {
      const slide = this.slides[0];
      if (!slide || !this.track) return 0;
      const gap = parseInt(getComputedStyle(this.track).gap) || 16;
      return slide.offsetWidth + gap;
    }

    navigate(direction) {
      if (!this.track) return;
      this.track.scrollBy({ left: direction * this.getSlideWidth(), behavior: 'smooth' });
    }

    goTo(index) {
      const slide = this.slides[index];
      if (!slide || !this.track) return;
      this.track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }

    onScroll() {
      this.updateDots();
      this.updateButtons();
    }

    updateDots() {
      if (!this.dots || !this.dots.length || !this.track) return;
      const slideWidth = this.getSlideWidth();
      if (slideWidth === 0) return;
      const activeIndex = Math.round(this.track.scrollLeft / slideWidth);
      this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === activeIndex));
    }

    updateButtons() {
      if (!this.track) return;
      const maxScroll = this.track.scrollWidth - this.track.clientWidth;
      if (this.prevBtn) this.prevBtn.disabled = this.track.scrollLeft <= 0;
      if (this.nextBtn) this.nextBtn.disabled = this.track.scrollLeft >= maxScroll - 1;
    }
  }

  if (!customElements.get('collage-slider')) {
    customElements.define('collage-slider', CollageSlider);
  }

  } catch(e) { console.error(e); }
})();
})();
